/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import AliianceManagerLayout from "../../../components/layouts/AliianceManagerLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import { useQuery } from "react-query";
import ReferralPartnerServices from "../../../services/API/ReferralPartner";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import Loader from "../../../components/Loader";
import { addDays, format } from "date-fns";
import Pagination from "react-js-pagination";
import ReferralPartnerFilter from "../../../components/ReferralPartnerFilter";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";

const initial = {
    name: "",
    coupon_code: "",
    dueDateRange: [
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ],
    dateSubmit: false,
};
const ReferralCoupons = () => {
    const [page, setPage] = useState(1);
    const [adItem, setADItem] = useState("");
    const [loader, setLoader] = useState("");
    const [genLoader, setGenLoader] = useState("");
    const [showFilter, setShowFilter] = useState("");
    const [filters, setFilters] = useState(initial);
    const [displaySearchField, setDisplaySearchField] = useState(false);
    const [clearFilters, setCleafilters] = useState(false);
    const [showDuedateRange, setShowDuedateRange] = useState(false);
    const [showReqDateRange, setShowReqDateRange] = useState(false);
    const [reason, setReason] = useState("");
    const [row_no, setNo] = useState("");
    const [q, setq] = useState("");
    const [id, setId] = useState(null);
    const [edit, setEdit] = useState(false);
    const [show, setShow] = useState(false);
    const [add, setAdd] = useState(false);
    const limit = 20;
    const [startDate, setStartDate] = useState(null);

    const queryKey = `/api/referral-coupons-list`;
    const {
        data: couponList,
        isFetching,
        isLoading: listLoading,
        isSuccess: success,
        isRefetching,
        refetch,
    } = useQuery(
        [
            queryKey,
            {
                ...filters,
                q,
                limit: limit,
                page: page,
            },
        ],
        ReferralPartnerServices.getAllReferralCoupons,
        {
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    );

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, [couponList, page]);

    const generateCoupon = async () => {
        try {
            setGenLoader(true);
            const res = await ReferralPartnerServices.generateCoupon();
            if (res?.data) {
                setEdit(prev => ({
                    ...prev,
                    coupon_code: res.data
                }));
            }
            setGenLoader(false);
        } catch (error) {
            console.error("Error generating coupon:", error);
            alert("Failed to generate coupon");
        }
    };

    const submitForm = async () => {
        if (id) {
            updateForm();
        } else {
            edit.partner_comm = 0;
            edit.partner_discount_type = 'percent';
            addForm();
        }
    };

    const addForm = async () => {
        const error = validateCoupon(edit);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await ReferralPartnerServices.addCoupon(edit);
            if (response) {
                toast.success("Coupon added successfully");
                handleHide();
                refetch();
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const handleEdit = async (coupon) => {
        try {
            const couponData = await ReferralPartnerServices.editCoupon(coupon?.id);
            setId(coupon?.id);
            setEdit(couponData?.data);
            if (couponData?.data) {
                if (couponData?.data?.user_type != '5') {
                    setAdd(true);
                }
                setShow(true);
            }
        } catch (er) {
            toast.error(er);
        }
    };

    const updateForm = async () => {
        const error = validateCoupon(edit);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await ReferralPartnerServices.updateCoupon(id, edit);
            if (response) {
                toast.success("Coupon updated successfully");
                handleHide();
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateCoupon = (data) => {
        if (data.coupon_code == null || data.coupon_code === "")
            return "Please Enter Coupon Code";
        if (data.recurring_type == null || data.recurring_type === "")
            return "Please Enter Recurring Limit";
        if (data.limit_per_user == null || data.limit_per_user === "")
            return "Please Enter Limit Per User";
        if(add) {
            if (!data.partner_discount_type) return "Please Enter Partner Commission Type";
            if (!data.partner_comm) return "Please Enter Partner Commission";
            if (data.partner_discount_type === "percent") {
                if (data.partner_comm < 1 || data.partner_comm > 100) {
                    return "Partner Commission must be between 1 and 100";
                }
            }
            if (data.partner_discount_type === "flat") {
                if (data.partner_comm <= 0) {
                    return "Partner Commission must be greater than 0";
                }
            }
        }
        if (!data.user_discount_type) return "Please Enter User Discount Type";
        if (!data.user_discount) return "Please Enter User Discount";
        if (data.user_discount_type === "percent") {
            if (data.user_discount < 1 || data.user_discount > 100) {
                return "User Discount must be between 1 and 100";
            }
        }
        if (data.partner_discount_type === "flat") {
            if (data.user_discount <= 0) {
                return "User Discount must be greater than 0";
            }
        }
        if (!data.valid_from) return "Please Enter Valid From";
    };

    function validateNumber(value) {
        const regex = /^\d*\.?\d*$/;
        return regex.test(value);
    }

    const handleHide = () => {
        setShow(false);
        setId(null);
        setEdit(false);
        setAdd(false);
    };

    const updateCouponStatus = async () => {
        let statusToset = true;
        let status = '1';
        if (adItem?.status == 1) {
            statusToset = false;
            status = '0';
        }
        const menu = 'Coupon List';
        const payload = { statusToset, status, reason, menu, row_no };
        setLoader("update");
        const resp = await ReferralPartnerServices.updateCouponStatus(
            adItem?.id,
            payload
        );
        setLoader("");
        setADItem(null);
        if (resp.data.status == 0) {
            toast.success("Coupon Deactivated Successfully");
            refetch();
        } else {
            toast.success("Coupon Activated Successfully");
            refetch();
        }
    };

    const downloadReport = async () => {
        setLoader("download");
        const resp = await ReferralPartnerServices.downloadCouponReport();
        setLoader("");
        if (resp) {
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Coupon-Lists.csv");
            toast.success("Coupon Lists Downloaded Successfully");
            link.click();
        }
    };

    const cellClasses = "d-flex align-items-center h-full  ";

    return (
        <AliianceManagerLayout coupon="active">
            <AdminPageContainer>
                <Modal
                    show={!!adItem}
                    onHide={() => setADItem(null)}
                    animation={false}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Are you Sure?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            Do you want to{" "}
                            {adItem?.status == 1 ? "deactivate " : "activate "}
                            this Coupon?
                        </p>
                        {/* 13-Aug-2024 Karthikeyan p1 status log start */}
                        <div>
                            <p><label for="w3review">Reason <span style={{ color: "red" }}> *</span></label></p>
                            <textarea
                                id="w3review"
                                placeholder="Reason"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                style={{ width: "100%" }}
                                maxLength={500}
                            />
                        </div>
                        {/* 13-Aug-2024 Karthikeyan p1 status log end */}
                        <div className="d-flex gap-3 justify-content-end">
                            <Button
                                variant="danger"
                                className="px-3 py-2"
                                // button button_new
                                onClick={() => setADItem(null)}
                                disabled={loader === "update"}
                            >
                                No
                            </Button>
                            <Button
                                variant="success"
                                className="px-3 py-2"
                                // button_new
                                onClick={() => updateCouponStatus()}
                                disabled={loader === "update" || !reason}
                            >
                                {loader === "update" ? (
                                    <div className="d-flex align-items-center gap-2">
                                        <Loader /> loading...
                                    </div>
                                ) : (
                                    "Yes"
                                )}
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* {showFilter && (
                    <ReferralPartnerFilter
                        show={showFilter}
                        onHide={() => setShowFilter(false)}
                        setFilters={setFilters}
                        filters={filters}
                        setPage={setPage}
                        showDuedateRange={showDuedateRange}
                        setShowDuedateRange={setShowDuedateRange}
                    />
                )} */}

                <div id="main" role="main">
                    <div id="content">
                        <div>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/alliance-manager/dashboard"}>Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Coupon Lists</li>
                            </ol>
                        </div>
                        <div className="card card-sm card-shadow mb-3">
                            <div className="card-body">
                                <div className="d-flex justify-content-between">
                                    <h2>Coupon Lists </h2>
                                    <div className="d-flex justify-content-end align-items-center gap-2 pb-3">
                                        {(!!filters?.name ||
                                            !!filters?.coupon_code ||
                                            filters.dateSubmit ||
                                            !!q) && (
                                                <button
                                                    type="button"
                                                    className="button_new pull-right mt-1 px-3"
                                                    onClick={() => {
                                                        setq("");
                                                        setDisplaySearchField(false);
                                                        setFilters(initial);
                                                        setShowDuedateRange(false);
                                                        setShowReqDateRange(false);
                                                    }}
                                                >
                                                    Clear Filters
                                                </button>
                                            )}
                                        {displaySearchField ? (
                                            <label className="input m-0 mt-1">
                                                <input
                                                    type="text"
                                                    className="button_new "
                                                    value={q}
                                                    onChange={(e) => {
                                                        setPage(1);
                                                        setq(e.target.value);
                                                    }}
                                                    // disabled={workflow === "expert"}
                                                    placeholder="Search"
                                                // title="Search"
                                                />
                                            </label>
                                        ) : (
                                            <div>
                                                <a
                                                    className=" button_new "
                                                    onClick={() => {
                                                        setDisplaySearchField(true);
                                                    }}
                                                    onKeyDown={() => {
                                                        setDisplaySearchField(true);
                                                    }}
                                                >
                                                    <i
                                                        class="fa fa-fa fa-search requests-icons"
                                                        title="Search"
                                                        aria-hidden="true"
                                                    ></i>
                                                </a>
                                            </div>
                                        )}
                                        {/* <div>
                                            <a
                                                // href=""
                                                onClick={() => setShowFilter(true)}
                                                onKeyDown={() => setShowFilter(true)}
                                                target="_blank"
                                                className="button_new"
                                            // style={{ marginRight: "45px" }}
                                            >
                                                <i
                                                    className="fa fa-filter fa-fw requests-icons"
                                                    title="Show Filters"
                                                ></i>
                                            </a>
                                        </div> */}

                                        <div>
                                            <a
                                                onClick={() => downloadReport()}
                                                onKeyDown={() => downloadReport()}
                                                target="_blank"
                                                className="button_new"
                                            >
                                                <i
                                                    // style={{ marginRight: "90px" }}
                                                    className="fa fa-download requests-icons"
                                                    title="Download"
                                                ></i>
                                            </a>
                                        </div>
                                        <div>
                                            <a
                                                className=" button_new "
                                                onClick={() =>
                                                    setShow(true)
                                                }
                                                onKeyDown={() =>
                                                    setShow(true)
                                                }
                                            >
                                                <i
                                                    className="fa fa-plus fa-fw requests-icons"
                                                    title="Add Coupon Code"
                                                ></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="max-w-100 overflow-auto">
                                    <div className="table-responsive">
                                        <table
                                            className="table table-bordered table-hover dataTable no-footer"
                                            style={{ tableLayout: "fixed" }}
                                        >
                                            <thead>
                                                <tr style={{ backgroundColor: "#eee" }}>
                                                    <th width="35px" className="text-center  align-top">
                                                        S. No.
                                                    </th>
                                                    <th className="text-center  align-top" width="140px">
                                                        Name
                                                    </th>
                                                    <th className="text-center  align-top" width="140px">
                                                        Coupon Code
                                                    </th>
                                                    <th className="text-center  align-top" width="130px">
                                                        Status
                                                    </th>
                                                    {/* <th className="text-center  ">Status</th> */}
                                                    <th className="text-center  align-top" width="100px">
                                                        Created On
                                                    </th>
                                                    <th width="50px" className="text-center align-top ">
                                                        Actions
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {couponList?.data?.data?.length ? (
                                                    couponList?.data?.data.map((coupon, index) => {
                                                        return (
                                                            <tr key={coupon?.id}>
                                                                <td>
                                                                    <div className={cellClasses}>
                                                                        <div>{limit * (page - 1) + index + 1}</div>
                                                                    </div>
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        wordWrap: "break-word",
                                                                        whiteSpace: "pre-line",
                                                                    }}
                                                                >
                                                                    {coupon?.user_type == 5 ? (
                                                                        coupon?.name
                                                                    ) : (
                                                                        <Link
                                                                            to={`/alliance-manager/referral-partner/details/${coupon?.user_id}`}
                                                                        >
                                                                            {coupon?.name}
                                                                        </Link>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {coupon?.coupon_code}
                                                                </td>
                                                                <td>
                                                                    <div className={cellClasses}>
                                                                        {coupon?.status == "0"
                                                                            ? "Inactive"
                                                                            : coupon?.status == "1"
                                                                                ? "Active"
                                                                                : ""}
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className={cellClasses}>
                                                                        {coupon?.created_at
                                                                            ? format(
                                                                                new Date(coupon?.created_at),
                                                                                "dd-MM-yy hh:mm a"
                                                                            )
                                                                            : ""}
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <a
                                                                        title="View"
                                                                        onClick={() => handleEdit(coupon)}
                                                                        onKeyDown={() => handleEdit(coupon)}
                                                                    >
                                                                        <i className="fa fa-pencil fa-fw cursor-pointer"></i>
                                                                    </a>

                                                                    {coupon?.status == 0 ? (
                                                                        <i
                                                                            className="fa fa-circle fa-fw txt-fail"
                                                                            title="Activate"
                                                                            style={{
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => { setADItem(coupon); setReason(""); setNo(limit * (page - 1) + index + 1) }}
                                                                            onKeyDown={() => setADItem(coupon)}
                                                                        ></i>
                                                                    ) : (
                                                                        ""
                                                                    )}

                                                                    {coupon?.status == 1 ? (
                                                                        <i
                                                                            className="fa fa-circle fa-fw txt-success pe-auto"
                                                                            style={{
                                                                                cursor: "pointer",
                                                                            }}
                                                                            title="Deactivate"
                                                                            onClick={() => { setADItem(coupon); setReason(""); setNo(limit * (page - 1) + index + 1) }}
                                                                            onKeyDown={() => setADItem(coupon)}
                                                                        ></i>
                                                                    ) : (
                                                                        ""
                                                                    )}

                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} className="p-2 text-center">
                                                            {listLoading || isFetching ? (
                                                                <Loader />
                                                            ) : (
                                                                "No data found"
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mr-2">
                                    {couponList?.data?.total > limit && (
                                        <Pagination
                                            activePage={couponList?.data?.current_page}
                                            itemsCountPerPage={limit}
                                            totalItemsCount={couponList?.data?.total}
                                            pageRangeDisplayed={5}
                                            onChange={(number) => setPage(number)}
                                        />
                                    )}
                                </div>
                                {show && (
                                    <Modal
                                        show={show}
                                        animation={false}
                                        onHide={handleHide}
                                        dialogClassName="modal-lg"
                                    >
                                        <Modal.Header closeButton>
                                            <h3 className="modal-title"> {edit ? "Edit Coupon" : "Add Coupon"}</h3>
                                        </Modal.Header>
                                        <Modal.Body
                                            style={{ height: "80vh", overflowY: "scroll" }}
                                        >
                                            <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                    Coupon Code <span style={{ color: "red" }}> *</span>
                                                </label>
                                                {id ? (
                                                    <input
                                                        type="text"
                                                        className="form-control mb-3"
                                                        placeholder="Enter Coupon Code"
                                                        value={edit?.coupon_code}
                                                        disabled
                                                        minLength={5}
                                                        onChange={(e) =>
                                                            setEdit(prev => ({
                                                                ...prev,
                                                                coupon_code: e.target.value
                                                            }))
                                                        }
                                                    />
                                                ) : (
                                                    <div className="d-flex gap-2">
                                                        <input
                                                            type="text"
                                                            className="form-control mb-3"
                                                            placeholder="Coupon Code"
                                                            value={edit?.coupon_code}
                                                            onChange={(e) =>
                                                                setEdit(prev => ({
                                                                    ...prev,
                                                                    coupon_code: e.target.value
                                                                }))
                                                            }
                                                        />

                                                        <button
                                                            type="button"
                                                            className="btn btn-info h-100"
                                                            onClick={generateCoupon}
                                                            disabled={genLoader}
                                                        >
                                                            Generate
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                    Recurring Limit <span style={{ color: "red" }}> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    placeholder="Enter Recurring Limit"
                                                    value={edit?.recurring_type ?? ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (validateNumber(value)) {
                                                            setEdit(prev => ({
                                                                ...prev,
                                                                recurring_type: value
                                                            }))
                                                        }
                                                    }}
                                                />
                                                <div className="note">
                                                    <strong>Note:</strong> Number of times this coupon can be used repeatedly.
                                                    Use 0 for unlimited recurring usage.
                                                </div>
                                            </div>
                                              <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                    Minimum Purchase Amount
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    placeholder="Enter Minimum Purchase Amount"
                                                    value={edit?.min_purchase_amt ?? ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (validateNumber(value)) {
                                                            setEdit(prev => ({
                                                                ...prev,
                                                                min_purchase_amt: value
                                                            }))
                                                        }
                                                    }}
                                                />
                                                <div className="note">
                                                    <strong>Note:</strong> Set the minimum order amount to use this coupon.
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                    Limit Per User<span style={{ color: "red" }}> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    placeholder="Enter Limit Per User"
                                                    value={edit?.limit_per_user ?? ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (validateNumber(value)) {
                                                            setEdit(prev => ({
                                                                ...prev,
                                                                limit_per_user: value
                                                            }))
                                                        }
                                                    }}
                                                />
                                                <div className="note">
                                                    <strong>Note:</strong> Maximum number of times a single user can use this coupon.
                                                    Use 0 for unlimited usage per user.
                                                </div>
                                            </div>
                                            {add && (
                                                <>
                                                    <div className="form-group">
                                                        <label htmlFor="tags">
                                                            {" "}
                                                            Partner Commission Type<span style={{ color: "red" }}> *</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            value={edit?.partner_discount_type ?? ""}
                                                            onChange={(e) =>
                                                                setEdit(prev => ({
                                                                    ...prev,
                                                                    partner_discount_type: e.target.value
                                                                }))
                                                            }
                                                        >
                                                            <option value="">Select Value</option>
                                                            <option value="percent">Percent</option>
                                                            <option value="flat">Flat</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="tags">
                                                            {" "}
                                                            Partner Commission Value<span style={{ color: "red" }}> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Partner Commission Value"
                                                            value={edit?.partner_comm ?? ""}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                if (validateNumber(value)) {
                                                                    setEdit(prev => ({
                                                                        ...prev,
                                                                        partner_comm: value
                                                                    }))
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                    User Discount Type<span style={{ color: "red" }}> *</span>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    value={edit?.user_discount_type ?? ""}
                                                    onChange={(e) =>
                                                        setEdit(prev => ({
                                                            ...prev,
                                                            user_discount_type: e.target.value
                                                        }))
                                                    }
                                                >
                                                    <option value="">Select Value</option>
                                                    <option value="percent">Percent</option>
                                                    <option value="flat">Flat</option>
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                    User Discount Value<span style={{ color: "red" }}> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    placeholder="Enter User Discount Value"
                                                    value={edit?.user_discount ?? ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (validateNumber(value)) {
                                                            setEdit(prev => ({
                                                                ...prev,
                                                                user_discount: value
                                                            }))
                                                        }
                                                    }}
                                                />
                                            </div>

                                             <div className="form-group">
                                                <label htmlFor="tags">
                                                    {" "}
                                                   Maximum Discount Amount
                                                   {/* <span style={{ color: "red" }}> *</span> */}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    placeholder="Enter Maximum Discount Amount"
                                                    value={edit?.max_discount_amt ?? ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (validateNumber(value)) {
                                                            setEdit(prev => ({
                                                                ...prev,
                                                                max_discount_amt: value
                                                            }))
                                                        }
                                                    }}
                                                />
                                                <div className="note">
                                                    <strong>Note:</strong> Set the maximum discount limit (only for percentage discounts).
                                                </div>
                                            </div>

                                            <div className="form-group add-coupon-datepicker">
                                                <label className="d-flex" htmlFor="tags">
                                                    {" "}
                                                    Valid From<span style={{ color: "red" }}> *</span>
                                                </label>
                                                <DatePicker
                                                    minDate={moment().toDate()}
                                                    selected={edit?.valid_from
                                                        ? new Date(edit.valid_from.split(" ")[0])
                                                        : null}
                                                    onChange={(date) =>
                                                        setEdit(prev => ({
                                                            ...prev,
                                                            valid_from: moment(date).format("YYYY-MM-DD")
                                                        }))
                                                    }
                                                    type="date"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="py-2 col-3"
                                                    placeholderText="DD/MM/YYYY"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    popperPlacement="top-start"
                                                    popperModifiers={[
                                                        {
                                                            name: "preventOverflow",
                                                            options: {
                                                                boundary: "viewport",
                                                            },
                                                        },
                                                    ]}
                                                />
                                            </div>

                                            <div className="form-group add-coupon-datepicker">
                                                <label className="d-block" htmlFor="tags">
                                                    {" "}
                                                    Valid Till
                                                </label>
                                                <DatePicker
                                                    minDate={
                                                        edit?.valid_from
                                                            ? new Date(edit.valid_from)
                                                            : moment().toDate()
                                                    }
                                                    selected={edit?.expire_date
                                                        ? new Date(edit.expire_date.split(" ")[0])
                                                        : null}
                                                    onChange={(date) =>
                                                        setEdit(prev => ({
                                                            ...prev,
                                                            expire_date: moment(date).format("YYYY-MM-DD")
                                                        }))
                                                    }
                                                    type="date"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="py-2 col-3"
                                                    placeholderText="DD/MM/YYYY"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <button
                                                type="button"
                                                className="btn button_new_success"
                                                onClick={submitForm}
                                            >
                                                Save
                                            </button>
                                        </Modal.Footer>
                                    </Modal>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </AdminPageContainer>
        </AliianceManagerLayout>
    );
};

export default ReferralCoupons;
